module.exports = __webpack_public_path__ + "img/02.25e4dddf.png";